import Viewer from './ViewerContainer';

export default Viewer;
